module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 78
// module chunks = 0 1 2 3 4 5 6 7 8 9